import { NewsAPI } from './news/newsapi'
import { EventsAPI } from './events/eventsapi'
import { EventModuleAPI } from './eventmodule/eventmoduleapi'

export class CompiereAPI {

    clientId: number;
    news: NewsAPI;
    events: EventsAPI;
    eventModule: EventModuleAPI;

    constructor(clientId: number) {
        this.clientId = clientId
        this.news = new NewsAPI(clientId);
        this.events = new EventsAPI(clientId);
        this.eventModule = new EventModuleAPI(clientId);
    }

}